export default __webpack_public_path__ + "static/media/person-7.d6fe33ef.png";